import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";

interface CellCountWithIconProps {
  params: any;
  children: number | string;
  onClick?: (params: any) => void;
}

const CellCountWithIcon = ({ params = {}, children, onClick }: CellCountWithIconProps) => {
  const count = Number(children);
  const showIcon = !isNaN(count) && count > 0;

  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Typography variant="body2">{children}</Typography>

      {showIcon && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onClick?.(params);
          }}
          size="small"
          sx={{
            color: "text.secondary",
            p: 0.5,
            "&:hover": {
              color: "text.primary",
            },
          }}
        >
          <GroupIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default CellCountWithIcon;
